import { useEffect, useState } from 'react';
import { Formik, Form, Field, FieldArray, ErrorMessage, useFormikContext } from 'formik';
import { KeenIcon, DefaultTooltip, LazyFormikSelect, DatePicker, RichTextEditorFormik } from '@/components';

const CreateInvoice = () => {
    const { values, setFieldValue } = useFormikContext();
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);
    const [allContact, setAllContacts] = useState([]);
    const [matterData, setMatterData] = useState([])
    const [subtotal, setSubtotal] = useState(0);
    const [total, setTotal] = useState(0);
    const [taxBreakdown, setTaxBreakdown] = useState({});
    const invoiceSettings = values.template_Settings?.invoice 
  
    // useEffect(() => {
    //   const allLineItems = [
    //     ...(values.items || []),
    //     ...(values.expenses || []),
    //     ...(values.flat_fees || [])
    //   ];
    //   console.log('allLineItems', allLineItems)
    //   let calculatedSubtotal = 0;
    //   let calculatedTotal = 0;
    //   const taxCounts = {};

    //   allLineItems.forEach((item, itemIndex) => {
    //     const quantity = Number(item.quantity) || 0;
    //     const price = Number(item.rate) || 0;
    //     const baseAmount = quantity * price;

    //     calculatedSubtotal += baseAmount;

    //     // Create a list of tax fields, even if duplicates
    //     const taxesInItem = [item.tax1, item.tax2];

    //     item.tax.forEach((tax, taxIndex) => {
    //       if (tax && tax.rate && tax.label) {
    //         const rate = parseFloat(tax.rate);
    //         const taxAmount = (baseAmount * rate) / 100;

    //         const key = `${tax.label}-${rate}`;

    //         if (!taxCounts[key]) {
    //           taxCounts[key] = {
    //             label: tax.label,
    //             rate,
    //             amount: 0,
    //             count: 0
    //           };
    //         }

    //         taxCounts[key].amount += taxAmount;
    //         taxCounts[key].count += 1;

    //         calculatedTotal += taxAmount;
    //       }
    //     });

    //     calculatedTotal += baseAmount;
    //   });

    //   setSubtotal(calculatedSubtotal);
    //   setTotal(calculatedTotal);
    //   setTaxBreakdown(taxCounts);
    //   setFieldValue('total', calculatedTotal); // this was wrong before (was using stale `total`)
    // }, [values.items, values.expenses, values.flat_fees, setFieldValue]);
    // console.log('allLineItems', allLineItems)
    useEffect(() => {
      const allLineItems = [
        ...(values?.time_entries || []),
        ...(values?.expenses || []),
        ...(values?.flat_fees || [])
      ];
       console.log('asd', allLineItems)
      let rawSubtotal = 0;
      const taxCounts = {};
      const taxMap = new Map();
      
      allLineItems.forEach((item) => {
        const quantity = Number(item.quantity) || 0;
        const price = Number(item.rate) || 0;
        const baseAmount = quantity * price;

        rawSubtotal += baseAmount;
      });

      // Apply discount if any
      const discountPercent = parseFloat(values.discount_percent) || 0;
      const discountAmount = (rawSubtotal * discountPercent) / 100;
      const discountedSubtotal = rawSubtotal - discountAmount;

      let totalTaxAmount = 0;

      allLineItems.forEach((item) => {
        const quantity = Number(item.quantity) || 0;
        const price = Number(item.rate) || 0;
        const baseAmount = quantity * price;
        const discountedBase = baseAmount - (baseAmount * discountPercent) / 100;
        const taxes =
          Array.isArray(item?.taxes) && item.taxes.length
            ? item.taxes
            : Array.isArray(item?.tax)
              ? item.tax
              : [];

        taxes.forEach((tax) => {
          if (tax?.rate && tax?.label) {
            const rate = parseFloat(tax.rate);
            const taxAmount = (discountedBase * rate) / 100;

            const key = `${tax.label}-${rate}`;

            if (!taxCounts[key]) {
              taxCounts[key] = {
                label: tax.label,
                rate,
                amount: 0,
                count: 0
              };
            }

            taxCounts[key].amount += taxAmount;
            taxCounts[key].count += 1;

            totalTaxAmount += taxAmount;
            if (!taxMap.has(tax.id)) {
              taxMap.set(tax.id, {
                id: tax.id,
                label: tax.label,
                value: tax.id,
                rate: tax.rate
              });
            }
          }
        });
      });

      const finalTotal = discountedSubtotal + totalTaxAmount;

      setSubtotal(rawSubtotal);
      setTotal(finalTotal);
      setTaxBreakdown(taxCounts);

      // Set Formik values
      setFieldValue('subtotal', rawSubtotal);
      setFieldValue('discount', discountAmount);
      setFieldValue('subtotal_after_discount', discountedSubtotal);
      setFieldValue('total', finalTotal);
      setFieldValue('taxes', Array.from(taxMap.values()));
    }, [values.time_entries, values.expenses, values.flat_fees, values.discount_percent, setFieldValue]);
   
  

    return (
        <>
        <div className='flex items-center my-5'>
            <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
            <p className='text-sm shrink-0 w-fit px-4'>Create Invoice</p>
            <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
        </div>
        <div className='flex items-start lg:flex-nowrap flex-wrap gap-5'>
          {invoiceSettings?.show_note && (
            <div className='lg:w-1/2 w-full'>
                <div className='flex items-center'>
                  <span className='w-12 h-0.5 bg-border inline-block mr-2'></span>
                  <DefaultTooltip title='This is the note that will be displayed on the invoice' placement="bottom" className="max-w-full">
                    <label className="w-fit form-label items-center gap-1">
                      <KeenIcon icon="information" />
                      <p className='text-sm'>{invoiceSettings?.note_label || 'Note'}</p>
                    </label>
                  </DefaultTooltip>
                </div>
                <div className="space-y-5 mt-5">
                    <div>
                        <Field name="terms_and_conditions_note" component={RichTextEditorFormik} />
                    </div>
                </div>
            </div>
          )}
            {invoiceSettings?.show_terms_conditions && (
              <div className='lg:w-1/2 w-full'>
                <div className='flex items-center'>
                  <span className='w-12 h-0.5 bg-border inline-block mr-2'></span>
                  <p className='text-sm'>{invoiceSettings?.terms_conditions_label || 'Terms & Conditions'}</p>
                </div>

                <div className="space-y-5 mt-5">
                  <div>
                    <Field  name="terms_and_conditions" component={RichTextEditorFormik} />
                  </div>
                </div>
              </div>
            )}
        </div>
        {/* <div className="sm:w-1/2 space-y-2 mt-5 text-sm text-gray-700">
          <div className="flex justify-between font-medium">
            <span>Subtotal:</span>
            <span>${subtotal.toFixed(2)}</span>
          </div>

          {Object.values(taxBreakdown).map(({ label, rate, amount, count }) => (
            <div key={`${label}-${rate}`} className="flex justify-between ml-2 text-xs relative">
              <span className="flex items-center gap-1">
                {label} ({rate}%)
                {count > 1 && (
                  <span className="text-[9px] font-semibold bg-dark text-white rounded-full w-4.5 h-4.5 flex items-center justify-center">
                    x{count}
                  </span>
                )}
              </span>
              <span>${amount.toFixed(2)}</span>
            </div>
          ))}

          <div className="text-xs flex justify-between font-medium border-t border-dashed pt-2 mt-2">
            <span>Total (USD):</span>
            <span>${total.toFixed(2)}</span>
            <Field type="text" name={`total`} disabled className="sr-only" />
          </div>

          <div className="text-xs flex justify-between font-medium text-success">
            <span>Balance Due:</span>
            <span>${total.toFixed(2)}</span>
          </div>
        </div> */}
        <div className="sm:w-1/2 space-y-2 mt-5 text-sm text-gray-700">
          <div className="flex justify-between font-medium">
            <span>Subtotal:</span>
            <span>${subtotal.toFixed(2)}</span>
          </div>

          {Number(values.discount_percent) > 0 && (
            <>
              <div className="flex justify-between">
                <span>Discount ({values.discount_percent}%):</span>
                <span>-${((subtotal * values.discount_percent) / 100).toFixed(2)}</span>
              </div>

              <div className="flex justify-between font-medium">
                <span>Subtotal after Discount:</span>
                <span>${(subtotal - (subtotal * values.discount_percent) / 100).toFixed(2)}</span>
              </div>
            </>
          )}

          {Object.values(taxBreakdown).map(({ label, rate, amount, count }) => (
            <div key={`${label}-${rate}`} className="flex justify-between ml-2 text-xs relative">
              <span className="flex items-center gap-1">
                {label} ({rate}%)
                {count > 1 && (
                  <span className="text-[9px] font-semibold bg-dark text-white rounded-full w-4.5 h-4.5 flex items-center justify-center">
                    x{count}
                  </span>
                )}
              </span>
              <span>${amount.toFixed(2)}</span>
            </div>
          ))}

          <div className="text-xs flex justify-between font-medium border-t border-dashed pt-2 mt-2">
            <span>Total (USD):</span>
            <span>${total.toFixed(2)}</span>
            <Field type="text" name={`total`} disabled className="sr-only" />
          </div>

          <div className="text-xs flex justify-between font-medium text-success">
            <span>Balance Due:</span>
            <span>${total.toFixed(2)}</span>
          </div>
        </div>
        </>
    )
}

export { CreateInvoice }
